module.exports = __webpack_public_path__ + "img/browse-vehicles-search-background-mistu.910a209f.png";